// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_ga","advertDetailParameterList__header":"c-q_gb","advertDetailParameterList__list":"c-q_gc"};